import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function PrivacyPolicyModal({ open, onOpenChange, clinicName }) {
  const clinic = clinicName || "the clinic";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="privacy-policy-modal">
        <DialogHeader>
          <DialogTitle>Privacy Policy &amp; Patient Consent</DialogTitle>
        </DialogHeader>
        <div className="text-sm text-slate-700 space-y-3 leading-relaxed">
          <p>
            {clinic} values your privacy. We collect and process your personal and health
            information in accordance with the <b>Data Privacy Act of 2012 (Republic Act No. 10173)</b>,
            its Implementing Rules and Regulations, and applicable issuances of the National Privacy Commission.
          </p>

          <div>
            <h3 className="font-semibold text-slate-900">1. Information we collect</h3>
            <p>
              When you book an appointment we collect your full name, contact number, email (if provided),
              reason for visit, and appointment details. During your visit and care, we may also collect
              medical and clinical information such as vital signs, diagnoses, clinical notes, prescriptions,
              laboratory/imaging results, and billing records.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">2. How we use your information</h3>
            <p>
              To schedule and manage your appointment, provide and coordinate medical care, verify your
              identity, communicate with you regarding your visit, process payments, and maintain your
              medical record as required for healthcare and legal purposes.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">3. Sharing and disclosure</h3>
            <p>
              Your information is accessed only by your attending physician and authorized clinic personnel
              involved in your care. It may be shared with an affiliated hospital or specialist when you are
              referred or transferred, and when required by law or lawful order. <b>We do not sell your
              personal information.</b>
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">4. Data security</h3>
            <p>
              We protect your information using encryption in transit (HTTPS/TLS), role-based access controls
              that limit who can view your records, and audit logging of access to sensitive data.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">5. Retention</h3>
            <p>
              We retain your records for the period required by law and clinic policy for medical records,
              after which they are securely disposed of or anonymized.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">6. Your rights</h3>
            <p>
              Under the Data Privacy Act, you have the right to be informed, to access and correct your data,
              to object to processing, to data portability, and to request erasure or blocking, subject to
              legal and medical record-keeping requirements. You may also lodge a complaint with the National
              Privacy Commission.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">7. Consent</h3>
            <p>
              By booking an appointment and clicking &ldquo;I agree,&rdquo; you acknowledge that you have read
              and understood this Privacy Policy and consent to the collection, use, and processing of your
              personal and health information as described above.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">8. Contact</h3>
            <p>
              For privacy concerns or to exercise your rights, please contact {clinic} or its Data Protection
              Officer through the clinic&rsquo;s official contact channels.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
